
const svg = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 4H2V19H6V22L12.2857 19H22V4Z" fill="currentColor"></path></svg>';export default svg;
    